import { HttpParams } from '@angular/common/http';
import {Component, Input, OnInit} from '@angular/core';
import {Timeline} from '../../models/Timeline/timeline.object';
import {TimelineService} from '../../models/Timeline/timeline.service';
import {FilterObject} from '../../objects/filter-object';
import {MatDialog} from '@angular/material/dialog';
import {PageEvent} from '@angular/material/paginator';
import {TimelineEditorComponent} from '../../dialogs/timeline-editor/timeline-editor.component';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.css'],
    providers: [TimelineService],
    standalone: false
})
export class TimelineComponent implements OnInit {

  @Input() Model: string = null;
  @Input() ParentId: string = null;
  @Input() Title: string = 'Timeline';

  List: Timeline[] = [];
  filterObject: FilterObject = new FilterObject();

  constructor(public _Timeline: TimelineService, public dialog: MatDialog) {
    this.filterObject.include = ['Type'];
    this.filterObject.order = 'Start DESC';
    this.filterObject.limit = 10;
  }

  ngOnInit() {
    this.getData();
  }

  public getData(id: string = this.ParentId) {
    this.filterObject.loading = true;
    this.List = [];
    this.filterObject.where = {'and': [{'ParentId': id}, {'Model': this.Model}]};
    const Params = new HttpParams().append('filter', JSON.stringify(this.filterObject));
    this._Timeline.get(Params).subscribe(res => {
      this.List = res;
      this.filterObject.loading = false;
    });
    const whereParams = new HttpParams().append('where', JSON.stringify(this.filterObject.where));
    this._Timeline.count(whereParams).subscribe(countRes => {
      this.filterObject.count = countRes.count;
    });
  }

  pageChange(event: PageEvent) {
    this.filterObject.skip = event.pageIndex * event.pageSize;
    this.filterObject.limit = event.pageSize;
    this.getData();
  }

  openTimelineEditor(timeline?: Timeline, metadata?) {
    if (!timeline) {
      timeline = new Timeline(metadata);
    }
    this.dialog.open(TimelineEditorComponent, {data: {timeline, list: this.List}});
  }

  limitText(input: string) {
    return input.length > 255 ? input.substring(0, 255) + '...' : input;
  }
}
